export default __webpack_public_path__ + "static/media/OPManagement.8b053a64.svg";